/* global axios */
import ApiClient from '../ApiClient';

// Taxonomia oficial (fase 2): o que a planilha do clube manda fazer nesta conversa —
// causa raiz provável, responsável, prazo e protocolo. Usado pelo modal de pendência.
class TaxonomiaAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  sugestao(conversationId) {
    return axios.get(`${this.url}/${conversationId}/taxonomia`);
  }

  // Causa raiz confirmada pelo agente na tabulação (T-112).
  gravarCausa(conversationId, causaRaiz) {
    return axios.post(`${this.url}/${conversationId}/taxonomia`, {
      causa_raiz: causaRaiz,
    });
  }
}

export default new TaxonomiaAPI();
